export default function (ids, external=false) {
    let a = document.createElement('a');
    let routeName = 'documents.download';
    if (external) {
        routeName = 'external.' + routeName;
    }

    a.setAttribute('href', route(routeName, {documents: ids}));
    a.setAttribute('target', '_blank');
    a.click();
    a.remove();
}
